import { put } from 'redux-saga/effects'
import importer from 'common/importer'
const { getMigrationStatus, resetPassword, migrationResetPassword } = importer('APIs/users', null)
const UserActions = importer('Stores/Users/Actions')

export default function * main ({ email }) {
  try {
    yield put(UserActions.resetPasswordLoading())
    const checkResponse = yield getMigrationStatus(email)
    const isMigrated = checkResponse.data.isMigrated
    let resetResponse
    if (isMigrated) {
      resetResponse = yield resetPassword(email)
    } else {
      resetResponse = yield migrationResetPassword(email)
    }
    yield put(UserActions.resetPasswordSuccess(resetResponse))
  } catch (error) {
    yield put(UserActions.resetPasswordFailure(error))
  }
}
